import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import CreateFillExcavationMaterialPage from "./CreateFillExcavationMaterialForm";
import EditFillExcavationPage from "./EditFillExcavationMaterialForm";

export const CreateFillExcavationMaterialModule = () => {
  let { path } = useRouteMatch();
  return (
    
      <Switch>
        <ProtectedRoute exact path={path}>
              <CreateFillExcavationMaterialPage />
        </ProtectedRoute> 
        {/* <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
          <EditSetBacksPage />
        </ProtectedRoute> */}
        <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
          <EditFillExcavationPage />
        </ProtectedRoute>     
        <Route>
          <NotFound />
        </Route>
      </Switch>
    
  );
};

export default CreateFillExcavationMaterialModule;
